// extracted by mini-css-extract-plugin
export var body = "_m6-0";
export var sectionHeader = "_m6-4";
export var shortcutColumns = "_m6-2";
export var shortcutList = "_m6-1";
export var shortcutSection = "_m6-3";